<template>
  <Button v-bind="{ ...defaultButtonProps, ...buttonProps }" @click="$emit('click')">
    <slot></slot>
  </Button>
</template>
<script>
import Button from 'UI/Button';
export default {
  components: {
    Button
  },
  props: {
    buttonProps: {
      type: Object,
      required: false,
      default: () => {}
    },
    highlighted: {
      type: Boolean,
      required: true
    },
    isEnabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    defaultButtonProps() {
      if (this.highlighted) {
        return {
          width: 'full',
          class: 'w-100',
          withGradient: true,
          gradient: 'var(--primary-color)',
          enabled: this.isEnabled
        };
      } else {
        return {
          width: 'full',
          class: 'w-100',
          shape: 'outline',
          withGradient: true,
          gradient: 'var(--gradient-horizontal)',
          enabled: this.isEnabled
        };
      }
    }
  }
};
</script>
